import parsePhoneNumberFromString from 'libphonenumber-js'

export function formatPhoneNumber(phoneNumber: string): string {
  // Try to parse the phone number
  const parsedPhoneNumber = parsePhoneNumberFromString(phoneNumber)

  return parsedPhoneNumber
    ? parsedPhoneNumber.formatInternational().replace(/\s+/g, ' ')
    : phoneNumber
}
